import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/app/config-service/app.config';
import { AccountRouterManager } from '../../controller/router-handler';
import { LoginModel } from '../../models/login.model';
import { postOtpServiceResModel } from '../../models/serviceResponse.model';
import { AccountModuleDisplayConfig, ACCOUNT_DISPLAY_CONFIG } from '../../module-config/module-config';
import { OtpService } from '../../services/otp.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  loginTypes: Array<any> = [];
  phoneNumber: string = '';
  obLogin = new LoginModel('', '', '', '', '', '', '');

  private accountRouter = new AccountRouterManager(this.router);

  constructor(
    private router: Router, 
    private translate: TranslateService, 
    private toastr: ToastrService, 
    private otpService: OtpService,
    @Inject(ACCOUNT_DISPLAY_CONFIG) private accountRouterConfig: AccountModuleDisplayConfig,
  ){
    this.accountRouter.setRouterConfig(accountRouterConfig.displayAreaConfig);

    if(AppConfig.settings.apiServer && AppConfig.settings.apiServer.loginTypes){
      this.loginTypes = AppConfig.settings.apiServer.loginTypes.filter(logintype => logintype.type !== "phone");
    }
    if(AppConfig.settings.apiServer.loginTypes.length > 0){
      this.obLogin.loginType = this.loginTypes[0].type;
    }
  }

  ngOnInit(): void {
  }

  changeLoginType(loginType: string){
    this.obLogin.loginType = loginType;
  }

  obSubmit(){
    this.obLogin.phoneNumber = this.phoneNumber.replace(/\D/g, "");
    this.obLogin.countryCode = 'tr';
    this.checkParameters()
  };

  async checkParameters(){
    if(this.obLogin.loginType == ''){
      this.toastr.error(this.translate.instant('DEFAULT_ERROR_MESSAGE'));
      return;
    }
    if(this.obLogin.loginType == 'phone' && this.obLogin.phoneNumber == ''){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_PHONE_NUMBER_MANDATORY_ERROR'));
      return;
    }
    if(this.obLogin.loginType == 'email' && this.obLogin.email == ''){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_EMAIL_MANDATORY_ERROR'));
      return;
    }
    if(this.obLogin.loginType == 'phone' && this.phoneNumber.length != 15){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obLogin.loginType == 'phone' && this.obLogin.phoneNumber.length != 10){
      this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_MISSING_PARAMETER_ERROR'));
      return;
    }
    if(this.obLogin.loginType == 'email'){
      var emailRegex = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      if(this.obLogin.email.length <= 5 || !emailRegex.test(this.obLogin.email)){
        this.toastr.error(this.translate.instant('ACCOUNT_LOGIN_VALID_EMAIL_ERROR'));
        return;
      }
    }

    let message = await this.register();
    if(message === ''){
      const loginRouteParams = {obLogin: this.obLogin, phoneNumber: this.phoneNumber};
      this.accountRouter.toLoginWithParams<typeof loginRouteParams>(loginRouteParams);
      //this.router.navigate(['/mobileLogin/login'], {state: {obLogin: this.obLogin, phoneNumber: this.phoneNumber}})
    } 
    else{
      this.toastr.error(message);
      return;
    }
  }

  async register(){
    return this.callOtpService()
      .then(function(values){
        return '';
      })
      .catch(function(err){
        return err;
      })
  }

  callOtpService(){
    return new Promise((resolve, reject) => {
      this.otpService.postOtp(this.obLogin).subscribe(
        (response: postOtpServiceResModel) => {
          if(response.error === true){
            return reject(response.message);
          }
          else{
            this.obLogin.refNo = response.refNo;
            return resolve(true);
          }
        },
        error => {
          return reject(error);
        }
      )
    })
  }
}
